import { TemplatePage } from './types';

const live_streaming_gradient_business_theme: TemplatePage = {
  header: {
    color: '#FED07A',
    icon: 'images/video-templates/business.jpg',
    title: 'Live Stream Templates — Gradient Business Theme',
    title_meta: 'Free Live Stream Overlay Templates — Gradient Business Theme',
    description_meta:
      'Make your live streams stand out from the rest with Wave.video’s customizable' +
      ' gradient-business-themed overlay templates.',
    description:
      'Make your live streams stand out from the rest with these customizable' +
      ' gradient-business-themed templates. Brand your broadcasts like a live streaming pro!'
  },
  footer: {
    category: 'Live Stream Gradient Business Theme',
    description:
      'With Wave.video’s wide collection of themed editable templates, you can effortlessly' +
      ' make your live streams more pro-looking and memorable. Impress your audience with' +
      ' branded intros, thumbnails, overlays, and lower thirds without hiring a professional' +
      ' team of designers and video editors. Becoming a first-class live streamer has never been easier!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Gradient Business Theme',
      search: { name: 'BusinessGradientTheme', tags: 'BusinessGradientTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_gradient_business_theme;
